export default "__VITE_ASSET__CWTVVXtQ__"